// extracted by mini-css-extract-plugin
export default {"base":"vp_MEk3z","textarea":"vp_k6Zte","append":"vp_Mo5c5","content":"vp_NhkoL","lang":"vp_bpczB"};